var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1020.362)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 657.054,
    cy: 437.094,
    r: 15.268,
    fill: "#9257a2",
    fillRule: "evenodd",
    transform: "translate(-672.561 578.308) scale(1.04795)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "#6c4676",
    d: "M20.693 31.295a16 16 0 0 0 .036-.01 16 16 0 0 0 1.501-.549 16 16 0 0 0 1.44-.695 16 16 0 0 0 1.365-.836 16 16 0 0 0 1.272-.967 16 16 0 0 0 1.172-1.092 16 16 0 0 0 1.054-1.2 16 16 0 0 0 .93-1.301 16 16 0 0 0 .797-1.387 16 16 0 0 0 .652-1.461 16 16 0 0 0 .371-1.115l-9.982-9.983A7.476 7.476 0 0 0 16 8.5c-4.136 0-7.5 3.364-7.5 7.5 0 2.068.841 3.943 2.2 5.3l9.993 9.995z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    transform: "translate(0 1020.362)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    fill: "#fff",
    d: "M8.5 1C4.364 1 1 4.364 1 8.5S4.364 16 8.5 16 16 12.636 16 8.5 12.636 1 8.5 1Zm0 1C12.096 2 15 4.904 15 8.5S12.096 15 8.5 15a6.492 6.492 0 0 1-6.467-7.166A6.492 6.492 0 0 1 8.5 2Zm-.008 2.494A.5.5 0 0 0 8 5v3H5a.5.5 0 1 0 0 1h3v3a.5.5 0 1 0 1 0V9h3a.5.5 0 1 0 0-1H9V5a.5.5 0 0 0-.508-.506Z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    transform: "translate(7.5 1027.862)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.4e4cff079421ed93a4009776b20c2185.svg";
export { ForwardRef as ReactComponent };